<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="performingRequest"
      :can-cancel="true"
    ></b-loading>
    <form action="">
      <div
        class="modal-card"
        style="width: auto"
      >
        <header class="modal-card-head">
          <p class="modal-card-title">Editar Usuário</p>
        </header>
        <section class="modal-card-body">
          <div style="min-width: 330px">
            <!-- Nome -->
            <b-field
              label="Nome"
              class="mw-300"
            >
              <b-input
                v-model="userData.name"
                placeholder="Nome"
              />
            </b-field>
            <!-- Sobrenome -->
            <b-field
              label="Sobrenome"
              class="mw-300"
            >
              <b-input
                v-model="userData.lastName"
                placeholder="Sobrenome"
              />
            </b-field>
            <!-- Email -->
            <b-field
              label="Email"
              class="mw-300"
            >
              <b-input
                v-model="userData.email"
                placeholder="Email"
              />
            </b-field>
            <div class="flex mw-300">
              <!-- Tipo -->
              <b-field
                label="Tipo"
                class="mw-300 flex-1"
              >
                <b-select
                  placeholder="Tipo de Usuário"
                  v-model="userData.userType"
                >
                  <option value="patient">
                    Cliente
                  </option>
                  <option value="professional">
                    Profissional
                  </option>
                </b-select>
              </b-field>
              <!-- Premium -->
              <b-field
                label="Premium"
                class="mw-300 flex-1"
                v-if="userData.userType == 'professional'"
              >
                <b-switch
                  v-model="userData.isPremium"
                  :disabled="premiumData.isRecurring"
                >
                  {{ userData.isPremium ? "Sim": "Não" }}
                </b-switch>
              </b-field>
            </div>
            <!-- Inicio Plano -->
            <div v-if="!premiumData.isRecurring">
              <b-field
                label="Início do Plano"
                class="mw-300"
                v-if="userData.isPremium && userData.userType == 'professional'"
              >
                <b-datepicker
                  placeholder="Selecione uma data..."
                  icon="calendar-today"
                  v-model="premiumData.premiumSince"
                  :month-names="monthNames"
                  :day-names="dayNames"
                >
                </b-datepicker>

              </b-field>
              <!-- Fim Plano -->
              <b-field
                label="Fim do Plano"
                class="mw-300"
                v-if="userData.isPremium  && userData.userType == 'professional'"
              >
                <b-datepicker
                  placeholder="Selecione uma data..."
                  icon="calendar-today"
                  v-model="premiumData.premiumUntil"
                  :month-names="monthNames"
                  :day-names="dayNames"
                >
                </b-datepicker>

              </b-field>
            </div>
            <div v-else>
              <b-message
                type="is-info"
                has-icon
              >
                Este usuário possui um pagamento recorrente ativo.
                Ao cancelar a recorrência, o status de usuário premium também será removido
              </b-message>
              <button
                class="button is-danger"
                type="button"
                @click="cancelRecurringPayments(userData.id)"
              >Cancelar Recorrência</button>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button
            class="button"
            type="button"
            @click="$parent.close()"
          >Cancelar</button>
          <button
            class="button is-primary"
            @click.prevent="saveChanges()"
          >Salvar</button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import { usersCollection, premiumUsersCollection, functions } from '../../firebaseConfig'

const monthNames = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
const dayNames = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S']

export default {
  props: {
    userData: Object
  },
  data () {
    return {
      performingRequest: false,
      name: '',
      lastName: '',
      email: '',
      userType: '',
      premiumData: {
        premiumSince: null,
        premiumUntil: null
      },
      monthNames,
      dayNames
    }
  },
  methods: {
    async saveChanges () {
      try {
        this.performingRequest = true
        await usersCollection
          .doc(this.userData.id)
          .set(this.userData)

        if (this.userData.isPremium) {
          if (this.premiumData.isRecurring === undefined) {
            this.premiumData.isRecurring = false
          }
          await premiumUsersCollection
            .doc(this.userData.id)
            .set(this.premiumData)
        }
      } catch (error) {
        console.error(error)
        this.$toasted.error('Não foi possível salvar as alterações. Tente novamente mais tarde')
      } finally {
        this.performingRequest = false
        this.$parent.close()
        this.$toasted.success('Alterações salvas com sucesso')
      }
    },

    async fecthPremiumData () {
      try {
        this.performingRequest = true

        const doc = await premiumUsersCollection
          .doc(this.userData.id)
          .get()

        if (doc.exists) {
          const hasDateInfo = doc.data().premiumSince && doc.data().premiumUntil

          if (hasDateInfo) {
            const { premiumSince, premiumUntil } = doc.data()

            this.premiumData = {
              premiumSince: premiumSince.toDate(),
              premiumUntil: premiumUntil.toDate()
            }
          }

          this.premiumData = {
            ...this.premiumData,
            isRecurring: doc.data().isRecurring
          }
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.performingRequest = false
      }
    },

    async cancelRecurringPayments (userId) {
      try {
        this.performingRequest = true
        const res = await functions.httpsCallable('pagseguro/cancel')({ userId })
        if (res.data.success) {
          this.$toasted.success('Assinatura cancelada com sucesso!')
        }
        this.userData.isPremium = false
        this.premiumData.isRecurring = false
      } catch (error) {
        console.error(error)
        this.$toasted.error('Um erro ocorreu ao tentar cancelar a assinatura. Tente novamente mais tarde')
      } finally {
        this.performingRequest = false
      }
    }
  },

  created () {
    if (this.userData.isPremium) {
      this.fecthPremiumData()
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
